<template>
    <div style="margin-top: 10px">
        <el-tag
            class="org-item"
            :type="org.type === 'dept'?'':'info'"
            v-for="(org, index) in _value"
            :key="index + '_org'"
            :closable="closable"
            size="mini"
            @close="removeOrgItem(index)"
        >
            {{ org.name || org.username || org.deptName || org.postName }}{{org.mobile ? `(${org.mobile})` : ''}}
        </el-tag>
    </div>
</template>

<script>
export default {
    name: 'OrgItems',
    props: {
        value: {
            type: Array,
                default: () => {
                return []
            },
        },
        closable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        _value: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            },
        },
    },
    data () {
        return {}
    },
    methods: {
        removeOrgItem (index) {
            this._value.splice(index, 1)
            this.$emit('remove')
        },
    },
  }
</script>
  
<style scoped>
    .org-item{
        margin: 5px;
    }
</style>
  